<template>
  <div class="relative w-11/12 lg:w-full mx-auto">
    <nav class="absolute flex w-full justify-center mt-2">
      <router-link to="/" title="Homepage" aria-label="homepage">
        <salvi-music-shop-logo></salvi-music-shop-logo>
      </router-link>
    </nav>
    <section class="flex justify-between items-center h-24" aria-label="Menubar">
      <div class="flex w-56 justify-start items-center z-40">
        <div class="pl-2">
          <button @click="toggleMenu;$emit('open-menu')" aria-label="Menu">
            <hamburger-icon></hamburger-icon>
          </button>
        </div>
        <div class="hidden md:block lg:block text-xs flex-wrap md:ml-10 w-full">
          <shipping-locale-switcher :aria-label="$t('menu.shipping-locale')"></shipping-locale-switcher>
        </div>
      </div>
      <div class="flex flex-row items-center">
        <div class="hidden md:block lg:block">
          <search :aria-label="$t('menu.search')"></search>
        </div>
        <account :aria-label="$t('menu.account')" />
        <cart :aria-label="$t('menu.cart')" />
      </div>
    </section>
  </div>
</template>

<script>
import HamburgerIcon from '@/components/graphics/HamburgerIcon.vue';
import ShippingLocaleSwitcher from '@/components/ShippingLocaleSwitcher.vue';
import SalviMusicShopLogo from '@/components/graphics/SalviMusicShopLogo.vue';
import Search from '@/components/graphics/Search.vue';
import Account from '@/components/Account.vue';
import Cart from '@/components/Cart.vue';

import { mapActions } from 'vuex';

export default {
  data() {
    return {
      showAccount: false,
    };
  },

  components: {
    HamburgerIcon,
    ShippingLocaleSwitcher,
    SalviMusicShopLogo,
    Search,
    Account,
    Cart,
  },

  methods: {
    ...mapActions({
      toggleMenu: 'toggleMenu',
    }),
  },

  closeAccount() {
    this.showAccount = false;
  },
};
</script>

<style lang="css" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 0.4s ease-in 0s;
}
</style>
